<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink" :displayType="displayType">
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <user :members="projectMemberships"/>
    </information>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" />
    <visibility-flags :project="project"></visibility-flags>
    <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :projectAwards="project.awards"/>
    <information v-if="project.categories && project.categories.length > 0 && showCategories" class="lower" :isRowLoading="isRowLoading" :isBlank="isBlank">
      <category-circles :categories="project.categories"></category-circles>
    </information>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import CategoryCircles from '../UI/Category.vue'
import ProjectImage from '../UI/ProjectImage'
import User from '../UI/User'
import VisibilityFlags from '../UI/visibilityFlags'
export default {
  name: 'JudgeTeamProject',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    User,
    CategoryCircles,
    VisibilityFlags
  },
  props: ['projectID', 'categoryID', 'storyType', 'isMarginless', 'isRowLoading', 'isPinnableRow', 'pinnedProjects', 'disableLink', 'displayType'],
  mixins: [base, visibility],
  computed: {
    showCategories: function () {
      return !this.$isBroadcomMasters && !this.$isGirlsAndSteam
    },
    projectMemberships: function () {
      return this.project.user ? [this.project.user] : []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
::v-deep .main-container .story-title {
  height: 44px;
@include mobile {
  height: 40px;
}
}
</style>
